import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy, TruncatedCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Instagram Feed on desktop: the mobile post without its own border, centred
 * in a desktop window, with the call to action in an outlined box.
 */
@Component({
  selector: 'app-meta-instagram-desktop-feed',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './instagram-desktop-feed.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [
    '../../../preview-common/instagram/instagram-feed-styles.scss',
    './instagram-desktop-feed.component.scss',
  ]
})
export class MetaInstagramDesktopFeedPreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly accountName = MetaPreviewCopy.INSTAGRAM_ACCOUNT_NAME;
  readonly avatar = MetaPreviewCopy.AVATAR;

  /** The same two-line caption as the mobile feed (77 characters on the mock). */
  get caption(): TruncatedCopy {
    return MetaPreviewCopy.caption(this.accountName, MetaPreviewCopy.primaryText(this.data), 77);
  }

  get cta(): string {
    return MetaPreviewCopy.cta(this.data);
  }
}
